import { BreadcrumbLink } from "~/components/Breadcrumbs";
import {
  createContentBlockPage,
  createContentBlockPageLoader,
} from "~/components/ContentBlockPage";

export const handle = {
  breadcrumb: () => <BreadcrumbLink to="/impressum">Impressum</BreadcrumbLink>,
};

export const loader = createContentBlockPageLoader("/impressum");

const Page = createContentBlockPage();

export default Page;
